import { validateContract } from '../../api/contractApi';

const VALIDATE_CONTRACT = 'efes/contractValidation/VALIDATE_CONTRACT';
const VALIDATE_CONTRACT_SUCCESS = 'efes/contractValidation/VALIDATE_CONTRACT_SUCCESS';
const VALIDATE_CONTRACT_FAIL = 'efes/contractValidation/VALIDATE_CONTRACT_FAIL';
const CLEAN_CONTRACT = 'efes/contractValidation/CLEAN_CONTRACT';

const initialState = {
  contract: null,
  isLoading: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case VALIDATE_CONTRACT:
      return {
        ...state,
        isLoading: true,
      };
    case VALIDATE_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contract: action.result,
      };
    case VALIDATE_CONTRACT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error.response.data.errors,
      };
    case CLEAN_CONTRACT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}

export function getContract(data) {
  return {
    actions: [
      { type: VALIDATE_CONTRACT },
      { type: VALIDATE_CONTRACT_SUCCESS },
      { type: VALIDATE_CONTRACT_FAIL },
    ],
    promise: validateContract(data),
  };
}

export const clearStore = () => ({
  type: CLEAN_CONTRACT,
});
